(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("camera-controls-integration", [], factory);
	else if(typeof exports === 'object')
		exports["camera-controls-integration"] = factory();
	else
		root["camera-controls-integration"] = factory();
})(self, function() {
return 